import React, { useEffect, useState } from "react";
import { Space, Row, Col, Typography, Tag, Avatar } from "antd";
const { Text, Title } = Typography;
const countryArr = [
  {
    name: "Afghanistan",
    iso: "AF",
  },
  {
    name: "Aland Islands",
    iso: "AX",
  },
  {
    name: "Albania",
    iso: "AL",
  },
  {
    name: "Algeria",
    iso: "DZ",
  },
  {
    name: "American Samoa",
    iso: "AS",
  },
  {
    name: "Andorra",
    iso: "AD",
  },
  {
    name: "Angola",
    iso: "AO",
  },
  {
    name: "Anguilla",
    iso: "AI",
  },
  {
    name: "Antigua and Barbuda",
    iso: "AG",
  },
  {
    name: "Argentina",
    iso: "AR",
  },
  {
    name: "Armenia",
    iso: "AM",
  },
  {
    name: "Aruba",
    iso: "AW",
  },
  {
    name: "Australia",
    iso: "AU",
  },
  {
    name: "Austria",
    iso: "AT",
  },
  {
    name: "Azerbaijan",
    iso: "AZ",
  },
  {
    name: "Bahamas",
    iso: "BS",
  },
  {
    name: "Bahrain",
    iso: "BH",
  },
  {
    name: "Bangladesh",
    iso: "BD",
  },
  {
    name: "Barbados",
    iso: "BB",
  },
  {
    name: "Belarus",
    iso: "BY",
  },
  {
    name: "Belgium",
    iso: "BE",
  },
  {
    name: "Belize",
    iso: "BZ",
  },
  {
    name: "Benin",
    iso: "BJ",
  },
  {
    name: "Bermuda",
    iso: "BM",
  },
  {
    name: "Bhutan",
    iso: "BT",
  },
  {
    name: "Bolivia",
    iso: "BO",
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    iso: "BQ",
  },
  {
    name: "Bosnia and Herzegovina",
    iso: "BA",
  },
  {
    name: "Botswana",
    iso: "BW",
  },
  {
    name: "Brazil",
    iso: "BR",
  },
  {
    name: "British Virgin Islands",
    iso: "VG",
  },
  {
    name: "Brunei",
    iso: "BN",
  },
  {
    name: "Bulgaria",
    iso: "BG",
  },
  {
    name: "Burkina Faso",
    iso: "BF",
  },
  {
    name: "Burundi",
    iso: "BI",
  },
  {
    name: "Cambodia",
    iso: "KH",
  },
  {
    name: "Cameroon",
    iso: "CM",
  },
  {
    name: "Canada",
    iso: "CA",
  },
  {
    name: "Cape Verde",
    iso: "CV",
  },
  {
    name: "Cayman Islands",
    iso: "KY",
  },
  {
    name: "Central African Republic",
    iso: "CF",
  },
  {
    name: "Chad",
    iso: "TD",
  },
  {
    name: "Chile",
    iso: "CL",
  },
  {
    name: "China",
    iso: "CN",
  },
  {
    name: "Christmas Island",
    iso: "CX",
  },
  {
    name: "Cocos Islands",
    iso: "CC",
  },
  {
    name: "Colombia",
    iso: "CO",
  },
  {
    name: "Comoros",
    iso: "KM",
  },
  {
    name: "Congo",
    iso: "CG",
  },
  {
    name: "Cook Islands",
    iso: "CK",
  },
  {
    name: "Costa Rica",
    iso: "CR",
  },
  {
    name: "Côte d'Ivoire",
    iso: "CI",
  },
  {
    name: "Croatia",
    iso: "HR",
  },
  {
    name: "Cuba",
    iso: "CU",
  },
  {
    name: "Curaçao",
    iso: "CW",
  },
  {
    name: "Cyprus",
    iso: "CY",
  },
  {
    name: "Czech Republic",
    iso: "CZ",
  },
  {
    name: "Democratic Republic of the Congo",
    iso: "CD",
  },
  {
    name: "Denmark",
    iso: "DK",
  },
  {
    name: "Djibouti",
    iso: "DJ",
  },
  {
    name: "Dominica",
    iso: "DM",
  },
  {
    name: "Dominican Republic",
    iso: "DO",
  },
  {
    name: "Ecuador",
    iso: "EC",
  },
  {
    name: "Egypt",
    iso: "EG",
  },
  {
    name: "El Salvador",
    iso: "SV",
  },
  {
    name: "Equatorial Guinea",
    iso: "GQ",
  },
  {
    name: "Eritrea",
    iso: "ER",
  },
  {
    name: "Estonia",
    iso: "EE",
  },
  {
    name: "Ethiopia",
    iso: "ET",
  },
  {
    name: "Falkland Islands",
    iso: "FK",
  },
  {
    name: "Faroe Islands",
    iso: "FO",
  },
  {
    name: "Fiji",
    iso: "FJ",
  },
  {
    name: "Finland",
    iso: "FI",
  },
  {
    name: "France",
    iso: "FR",
  },
  {
    name: "French Guiana",
    iso: "GF",
  },
  {
    name: "French Polynesia",
    iso: "PF",
  },
  {
    name: "Gabon",
    iso: "GA",
  },
  {
    name: "Gambia",
    iso: "GM",
  },
  {
    name: "Georgia",
    iso: "GE",
  },
  {
    name: "Germany",
    iso: "DE",
  },
  {
    name: "Ghana",
    iso: "GH",
  },
  {
    name: "Gibraltar",
    iso: "GI",
  },
  {
    name: "Greece",
    iso: "GR",
  },
  {
    name: "Greenland",
    iso: "GL",
  },
  {
    name: "Grenada",
    iso: "GD",
  },
  {
    name: "Guadeloupe",
    iso: "GP",
  },
  {
    name: "Guam",
    iso: "GU",
  },
  {
    name: "Guatemala",
    iso: "GT",
  },
  {
    name: "Guernsey",
    iso: "GG",
  },
  {
    name: "Guinea-Bissau",
    iso: "GW",
  },
  {
    name: "Guinea",
    iso: "GN",
  },
  {
    name: "Guyana",
    iso: "GY",
  },
  {
    name: "Haiti",
    iso: "HT",
  },
  {
    name: "Holy See",
    iso: "VA",
  },
  {
    name: "Honduras",
    iso: "HN",
  },
  {
    name: "Hong Kong",
    iso: "HK",
  },
  {
    name: "Hungary",
    iso: "HU",
  },
  {
    name: "Iceland",
    iso: "IS",
  },
  {
    name: "India",
    iso: "IN",
  },
  {
    name: "Indonesia",
    iso: "ID",
  },
  {
    name: "Iran",
    iso: "IR",
  },
  {
    name: "Iraq",
    iso: "IQ",
  },
  {
    name: "Ireland",
    iso: "IE",
  },
  {
    name: "Isle of Man",
    iso: "IM",
  },
  {
    name: "Israel",
    iso: "IL",
  },
  {
    name: "Italy",
    iso: "IT",
  },
  {
    name: "Jamaica",
    iso: "JM",
  },
  {
    name: "Japan",
    iso: "JP",
  },
  {
    name: "Jersey",
    iso: "JE",
  },
  {
    name: "Jordan",
    iso: "JO",
  },
  {
    name: "Kazakhstan",
    iso: "KZ",
  },
  {
    name: "Kenya",
    iso: "KE",
  },
  {
    name: "Kiribati",
    iso: "KI",
  },
  {
    name: "Kosovo",
    iso: "XK",
  },
  {
    name: "Kuwait",
    iso: "KW",
  },
  {
    name: "Kyrgyzstan",
    iso: "KG",
  },
  {
    name: "Laos",
    iso: "LA",
  },
  {
    name: "Latvia",
    iso: "LV",
  },
  {
    name: "Lebanon",
    iso: "LB",
  },
  {
    name: "Lesotho",
    iso: "LS",
  },
  {
    name: "Liberia",
    iso: "LR",
  },
  {
    name: "Libya",
    iso: "LY",
  },
  {
    name: "Liechtenstein",
    iso: "LI",
  },
  {
    name: "Lithuania",
    iso: "LT",
  },
  {
    name: "Luxembourg",
    iso: "LU",
  },
  {
    name: "Macao",
    iso: "MO",
  },
  {
    name: "Madagascar",
    iso: "MG",
  },
  {
    name: "Malawi",
    iso: "MW",
  },
  {
    name: "Malaysia",
    iso: "MY",
  },
  {
    name: "Maldives",
    iso: "MV",
  },
  {
    name: "Mali",
    iso: "ML",
  },
  {
    name: "Malta",
    iso: "MT",
  },
  {
    name: "Marshall Islands",
    iso: "MH",
  },
  {
    name: "Martinique",
    iso: "MQ",
  },
  {
    name: "Mauritania",
    iso: "MR",
  },
  {
    name: "Mauritius",
    iso: "MU",
  },
  {
    name: "Mayotte",
    iso: "YT",
  },
  {
    name: "Mexico",
    iso: "MX",
  },
  {
    name: "Micronesia",
    iso: "FM",
  },
  {
    name: "Moldova",
    iso: "MD",
  },
  {
    name: "Monaco",
    iso: "MC",
  },
  {
    name: "Mongolia",
    iso: "MN",
  },
  {
    name: "Montenegro",
    iso: "ME",
  },
  {
    name: "Montserrat",
    iso: "MS",
  },
  {
    name: "Morocco",
    iso: "MA",
  },
  {
    name: "Mozambique",
    iso: "MZ",
  },
  {
    name: "Myanmar",
    iso: "MM",
  },
  {
    name: "Namibia",
    iso: "NA",
  },
  {
    name: "Nauru",
    iso: "NR",
  },
  {
    name: "Nepal",
    iso: "NP",
  },
  {
    name: "Netherlands Antilles",
    iso: "AN",
  },
  {
    name: "Netherlands",
    iso: "NL",
  },
  {
    name: "New Caledonia",
    iso: "NC",
  },
  {
    name: "New Zealand",
    iso: "NZ",
  },
  {
    name: "Nicaragua",
    iso: "NI",
  },
  {
    name: "Niger",
    iso: "NE",
  },
  {
    name: "Nigeria",
    iso: "NG",
  },
  {
    name: "Niue",
    iso: "NU",
  },
  {
    name: "Norfolk Island",
    iso: "NF",
  },
  {
    name: "North Korea",
    iso: "KP",
  },
  {
    name: "North Macedonia",
    iso: "MK",
  },
  {
    name: "Northern Mariana Islands",
    iso: "MP",
  },
  {
    name: "Norway",
    iso: "NO",
  },
  {
    name: "Oman",
    iso: "OM",
  },
  {
    name: "Pakistan",
    iso: "PK",
  },
  {
    name: "Palau",
    iso: "PW",
  },
  {
    name: "Palestine",
    iso: "PS",
  },
  {
    name: "Panama",
    iso: "PA",
  },
  {
    name: "Papua New Guinea",
    iso: "PG",
  },
  {
    name: "Paraguay",
    iso: "PY",
  },
  {
    name: "Peru",
    iso: "PE",
  },
  {
    name: "Philippines",
    iso: "PH",
  },
  {
    name: "Pitcairn",
    iso: "PN",
  },
  {
    name: "Poland",
    iso: "PL",
  },
  {
    name: "Portugal",
    iso: "PT",
  },
  {
    name: "Puerto Rico",
    iso: "PR",
  },
  {
    name: "Qatar",
    iso: "QA",
  },
  {
    name: "Réunion",
    iso: "RE",
  },
  {
    name: "Romania",
    iso: "RO",
  },
  {
    name: "Russia",
    iso: "RU",
  },
  {
    name: "Rwanda",
    iso: "RW",
  },
  {
    name: "Saint Barthélemy",
    iso: "BL",
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    iso: "SH",
  },
  {
    name: "Saint Kitts and Nevis",
    iso: "KN",
  },
  {
    name: "Saint Lucia",
    iso: "LC",
  },
  {
    name: "Saint Martin",
    iso: "MF",
  },
  {
    name: "Saint Pierre and Miquelon",
    iso: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    iso: "VC",
  },
  {
    name: "Samoa",
    iso: "WS",
  },
  {
    name: "San Marino",
    iso: "SM",
  },
  {
    name: "Sao Tome and Principe",
    iso: "ST",
  },
  {
    name: "Saudi Arabia",
    iso: "SA",
  },
  {
    name: "Senegal",
    iso: "SN",
  },
  {
    name: "Serbia",
    iso: "RS",
  },
  {
    name: "Seychelles",
    iso: "SC",
  },
  {
    name: "Sierra Leone",
    iso: "SL",
  },
  {
    name: "Singapore",
    iso: "SG",
  },
  {
    name: "Sint Maarten",
    iso: "SX",
  },
  {
    name: "Slovakia",
    iso: "SK",
  },
  {
    name: "Slovenia",
    iso: "SI",
  },
  {
    name: "Solomon Islands",
    iso: "SB",
  },
  {
    name: "Somalia",
    iso: "SO",
  },
  {
    name: "South Africa",
    iso: "ZA",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    iso: "GS",
  },
  {
    name: "South Korea",
    iso: "KR",
  },
  {
    name: "South Sudan",
    iso: "SS",
  },
  {
    name: "Spain",
    iso: "ES",
  },
  {
    name: "Sri Lanka",
    iso: "LK",
  },
  {
    name: "Sudan",
    iso: "SD",
  },
  {
    name: "Suriname",
    iso: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    iso: "SJ",
  },
  {
    name: "Swaziland",
    iso: "SZ",
  },
  {
    name: "Sweden",
    iso: "SE",
  },
  {
    name: "Switzerland",
    iso: "CH",
  },
  {
    name: "Syria",
    iso: "SY",
  },
  {
    name: "Taiwan",
    iso: "TW",
  },
  {
    name: "Tajikistan",
    iso: "TJ",
  },
  {
    name: "Tanzania",
    iso: "TZ",
  },
  {
    name: "Thailand",
    iso: "TH",
  },
  {
    name: "Timor-Leste",
    iso: "TL",
  },
  {
    name: "Togo",
    iso: "TG",
  },
  {
    name: "Tokelau",
    iso: "TK",
  },
  {
    name: "Tonga",
    iso: "TO",
  },
  {
    name: "Trinidad and Tobago",
    iso: "TT",
  },
  {
    name: "Tunisia",
    iso: "TN",
  },
  {
    name: "Turkey",
    iso: "TR",
  },
  {
    name: "Turkmenistan",
    iso: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    iso: "TC",
  },
  {
    name: "Tuvalu",
    iso: "TV",
  },
  {
    name: "Uganda",
    iso: "UG",
  },
  {
    name: "Ukraine",
    iso: "UA",
  },
  {
    name: "United Arab Emirates",
    iso: "AE",
  },
  {
    name: "United Kingdom",
    iso: "GB",
  },
  {
    name: "United States Minor Outlying Islands",
    iso: "UM",
  },
  {
    name: "United States",
    iso: "US",
  },
  {
    name: "Uruguay",
    iso: "UY",
  },
  {
    name: "Uzbekistan",
    iso: "UZ",
  },
  {
    name: "Vanuatu",
    iso: "VU",
  },
  {
    name: "Venezuela",
    iso: "VE",
  },
  {
    name: "Vietnam",
    iso: "VN",
  },
  {
    name: "Virgin Islands of the United States",
    iso: "VI",
  },
  {
    name: "Wallis and Futuna",
    iso: "WF",
  },
  {
    name: "Western Sahara",
    iso: "EH",
  },
  {
    name: "Yemen",
    iso: "YE",
  },
  {
    name: "Zambia",
    iso: "ZM",
  },
  {
    name: "Zimbabwe",
    iso: "ZW",
  },
];
const DetailTag = (props) => {
  const { tagTitle, icon, tag, ctag, ptag } = props;
  const [cData, setCData] = useState([]);
  useEffect(() => {
    setCData(
      countryArr?.filter((country) =>
        ctag?.some((filter) => filter.country_name === country.name)
      )
    );
  }, [ctag]);
  return (
    <Space direction="vertical">
      <Space align="center">
        {icon}
        <Title className="mb-0" level={5}>
          {tagTitle}
        </Title>
      </Space>
      <Row gutter={[24, 10]}>
        {cData?.length ? (
          cData?.map((value, index) => (
            <Col span={2.5}>
              <Tag
                icon={
                  <Avatar
                  style={{margin:'5px'}}
                    gap={20}
                    size={"small"}
                    src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${value?.iso}.svg`}
                  />
                }
                color="#F1EEFF"
                key={index}
              >
                {value?.name}
              </Tag>
            </Col>
          ))
        ) : ptag?.length ? (
          ptag?.map((value, index) => (
            <Col>
              <Tag color="#F1EEFF" key={index}>
                {value?.protocol_name}
              </Tag>
            </Col>
          ))
        ) : (
          <Col span={3}>
            <Tag color="#F1EEFF">{tag}</Tag>
          </Col>
        )}
      </Row>
    </Space>
  );
};

export default DetailTag;
